/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.with.js";
/**
 * 图片压缩
 * @param {*} file
 */
export function ImageCompression(file) {
  return new Promise(resolve => {
    //图片大于2M则压缩
    // if (file.size / 1024 / 1024 > 2) {
    // 判断是否支持FileReader
    if (!file || !window.FileReader) return;
    // 创建一个reader
    var reader = new FileReader();
    // 将图片转成base64格式
    reader.readAsDataURL(file.file);
    reader.onloadend = function () {
      let result = this.result;
      let img = new Image();
      img.src = result;
      img.onload = function () {
        let fileImg = dataURLtoFile(compress(img), file.file.name);
        resolve(fileImg);
      };
    };
    // } else {
    //   resolve(file.file);
    // }
  });
}

//base64 转文件流
function dataURLtoFile(base64Str, fileName) {
  var arr = base64Str.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    //base64解析出来的图片类型
    bstr = atob(arr[1]),
    //对base64串进行操作，去掉url头，并转换为byte   atob为window内置方法
    len = bstr.length,
    ab = new ArrayBuffer(len),
    //将ASCII码小于0的转换为大于0
    u8arr = new Uint8Array(ab); //
  while (len--) {
    u8arr[len] = bstr.charCodeAt(len);
  }
  // 创建新的 File 对象实例[utf-8内容，文件名称或者路径，[可选参数，type：文件中的内容mime类型]]
  return new File([u8arr], fileName, {
    type: mime
  });
}

// 压缩图片
function compress(img) {
  let canvas = document.createElement("canvas");
  let ctx = canvas.getContext("2d");
  let width = img.width;
  let height = img.height;
  canvas.width = width;
  canvas.height = height;
  // 铺底色
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(img, 0, 0, width, height);
  //进行最小压缩
  let ndata = canvas.toDataURL("image/jpeg", 0.1);
  return ndata;
}